// 请求层
import axios from 'axios'
import {
    Message,
    Loading
} from 'element-ui'

// 1. 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 10000 // 请求超时时间
})

// 2. 请求拦截器
let loadingInstance = null
service.interceptors.request.use(
    config => {
        // 打开加载动画
        loadingInstance = Loading.service({
            lock: true,
            text: '加载中...',
            background: 'rgba(0, 0, 0, 0.1)'
        })

        // 自动携带 token
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers['x-access-token'] = token
        }
        return config
    },
    error => {
        if (loadingInstance) loadingInstance.close()
        return Promise.reject(error)
    }
)

// 3. 响应拦截器
service.interceptors.response.use(
    response => {
        if (loadingInstance) loadingInstance.close()


        return response.data
        // 后端自定义状态码（根据你们后端改）
        // if (res.code !== 200) {
        //     Message({
        //         message: res.msg || '请求失败',
        //         type: 'error',
        //         duration: 3 * 1000
        //     })

        //     // 401：token 过期
        //     if (res.code === 401) {
        //         localStorage.removeItem('token')
        //         setTimeout(() => {
        //             window.location.href = '/login'
        //         }, 1000)
        //     }
        //     return Promise.reject(new Error(res.msg || 'Error'))
        // } else {
        //     return res
        // }
    },
    error => {
        if (loadingInstance) loadingInstance.close()

        // HTTP 错误处理
        if (error && error.response) {
            const msg = {
                401: '未授权，请重新登录'
            } [error.response.status] || '网络异常，请稍后再试'

            Message({
                message: msg,
                type: 'error',
                duration: 3 * 1000
            })
        } else {
            Message({
                message: '网络连接失败',
                type: 'error'
            })
        }
        return Promise.reject(error)
    }
)

export default service